import { Separator } from "@/components/ui/separator"
import { Link } from "react-router-dom"
import logo from "@/assets/images/zoe-fc-logo.jpeg"

export function Footer() {
  return (
    <footer className="bg-navy text-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4 text-ivory/60">
              About ZOE Football Academy
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-ivory/80 hover:text-gold transition-colors duration-200 text-sm">
                  Vision & Mission
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-ivory/80 hover:text-gold transition-colors duration-200 text-sm">
                  Core Values
                </Link>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4 text-ivory/60">
              Programs
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/programs" className="text-ivory/80 hover:text-gold transition-colors duration-200 text-sm">
                  Development Pathway
                </Link>
              </li>
              <li>
                <Link to="/international" className="text-ivory/80 hover:text-gold transition-colors duration-200 text-sm">
                  International Pathways
                </Link>
              </li>
            </ul>
          </div>

          {/* Nigeria Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gold">
              🇳🇬 Nigeria
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:nigeria@zoeventures.one" className="text-ivory/80 hover:text-gold transition-colors duration-200 text-sm">
                  nigeria@zoeventures.one
                </a>
              </li>
              <li>
                <a href="tel:+2348135091808" className="text-ivory/80 hover:text-gold transition-colors duration-200 text-sm">
                  +234 813 509 1808
                </a>
              </li>
              <li>
                <span className="text-ivory/60 text-sm">Suleja Township Stadium</span>
              </li>
            </ul>
          </div>

          {/* India Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gold">
              🇮🇳 India
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:india@zoeventures.one" className="text-ivory/80 hover:text-gold transition-colors duration-200 text-sm">
                  india@zoeventures.one
                </a>
              </li>
              <li>
                <a href="tel:+917348958352" className="text-ivory/80 hover:text-gold transition-colors duration-200 text-sm">
                  +91 73489 58352
                </a>
              </li>
              <li>
                <span className="text-ivory/60 text-sm">India Office</span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-ivory/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded overflow-hidden bg-ivory">
              <img src={logo} alt="ZOE Football Academy" className="w-full h-full object-cover" />
            </div>
            <span className="text-ivory/80 text-sm">
              © {new Date().getFullYear()} ZOE Football Academy. All rights reserved.
            </span>
          </div>
          <p className="text-ivory/60 text-sm">
            ⚽ Football Without Borders
          </p>
        </div>
      </div>
    </footer>
  )
}
